import { Avatar, AvatarProps } from "@fluentui/react-components";
import React from "react";

import { GOOGLE_IDP } from "../../config/idp";
import { AccountRaw } from "../../domain/Account";
import { MemberRaw } from "../../domain/Member";
import { getAvatarInitial } from "../../utils/getAvatarInitial";
import { randomColorFromSeed } from "../../utils/randomColorFromSeed";

export const getPersonaImageProps = (
  data: Partial<AccountRaw> | Partial<MemberRaw>
): Partial<AvatarProps> => {
  const {
    picture_image_url,
    picture_color,
    picture_type,
    identity_provider,
    uid,
    display_name,
  } = data;
  if (
    picture_image_url &&
    (picture_type === "image" || identity_provider === GOOGLE_IDP)
  ) {
    return { image: { src: picture_image_url } };
  }

  const backgroundColor = picture_color || randomColorFromSeed(uid || "");
  const initial = getAvatarInitial(display_name);
  return {
    initials: {
      children: initial,
      style: { backgroundColor, color: "#fff" } as React.CSSProperties,
    },
    icon: {
      style: { backgroundColor, color: "#fff" } as React.CSSProperties,
    },
  };
};

export const AccountPersona: React.FC<{
  account: AccountRaw | MemberRaw;
  size: AvatarProps["size"];
}> = ({ account, size }) => {
  const {
    picture_image_url,
    picture_color,
    picture_type,
    identity_provider,
    uid,
    display_name,
  } = account;
  return (
    <Avatar
      name={account.display_name}
      size={size}
      {...getPersonaImageProps({
        picture_image_url,
        picture_color,
        picture_type,
        identity_provider,
        uid,
        display_name,
      })}
    />
  );
};
